import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {getApolloError, cls} from '../../components/utils';
import {useWikiArticlesQuery} from '../../generated/types';
import {useRoute} from '../../lib/routes';
import {EditHoc} from '../../components/edit-hoc';
import {WikiView} from './view';
import {WikiHome} from './home/wiki-home';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

type Props = {};

export const WikiPage: React.FC<Props> = () => {
	const {data, loading, error} = useWikiArticlesQuery({
		ssr: true,
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.wikiArticles || [],
		id: query.id as string,
		loading,
		route: 'wikiArticle',
		baseRoute: 'wiki',
		sidebarHeader: (article) => article.title || '',
		sidebarSecondary: (article) => article.originalTitle,
	});

	const title = showView && selected ? selected.title : 'Вики';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="wiki" />}
			{notFound && <NotFoundSeo />}
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<WikiView wikiArticleId={selectedId} title={title} />
							) : (
								<EditHoc load={() => import('./edit-buttons').then((m) => m.CreateWiki)} editProps={{}}>
									<WikiHome />
								</EditHoc>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
